import React from 'react'
import PropTypes from 'prop-types'
import { HStack, Text, useTheme } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Toast from '../../../components/Toast/Toast'

export default function ActionButton({
  text,
  onCLick,
  icon,
  bgColor,
  textColor,
}) {
  const { colors } = useTheme()
  return (
    <Toast
      // w="100%"
      as="button"
      onClick={onCLick}
      variant="action"
      bgColor={bgColor || colors.gray[50]}
    >
      <HStack w="100%" spacing="10px" justifyContent="center">
        <FontAwesomeIcon color={textColor || '#676767'} icon={icon} />
        <Text variant="semibold" color={textColor || '#676767'}>
          {text}
        </Text>
      </HStack>
    </Toast>
  )
}

ActionButton.propTypes = {
  bgColor: PropTypes.string,
  icon: PropTypes.any,
  onCLick: PropTypes.func,
  text: PropTypes.string,
  textColor: PropTypes.string,
}
